import type { DamagePolygonType } from '@/common/damage-polygon';
import { axios } from '@/lib/utils/axios';
import { getResponse } from '../common';
import { API_URLS } from '../query.client';

export type AddDamagePolygonSuccessResponseType = DamagePolygonType;

export async function addDamagePolygon(
	payload: Omit<DamagePolygonType, 'id' | 'createdAt' | 'updatedAt' | 'createdById' | 'updatedById'>
): Promise<AddDamagePolygonSuccessResponseType | null> {
	const response = await axios.post(`${API_URLS.DAMAGE_POLYGONS.INDEX}`, payload);

	return getResponse<AddDamagePolygonSuccessResponseType>(response.data);
}
